const KO_MESSAGES = {
  control: "Control",
  survey: "서베이",
  consolePopup: "콘솔팝업",
  liveChannel: "라이브 채널",
  captionsPoc: "실시간 자막",
  exitPopup: "퇴장팝업",
  fmsMain: "FMS 메인",
  transmissionFms: "송출 FMS",
  afterSurvey: "사후서베이",
  progressSurvey: "진행서베이",
  beforeSurvey: "사전서베이",
  menuConnection: "메뉴연결",
  realtimeExposure: "실시간노출",
  surveyExposure: "서베이",
  surveyEdit: "서베이 수정",
  consolePopupEdit: "콘솔팝업 수정",
  testStreaming: "테스트 송출",
  started: "시작중",
  stopped: "정지",
  channelDetail: "채널 상세",
  channelId: "채널 ID",
  status: "상태",
  close: "닫기",
  cancel: "취소",
  basicInfo: "기본정보",
  usageHistory: "사용내역",
  requiredStreamingInfo: "송출 필수 정보",
  operationInfo: "운영 정보",
  affiliationInfo: "소속 정보",
  usageHistoryGuide: "선택한 채널에서 발생한 이벤트 현황을 확인할 수 있습니다.",
  allChannels: "전체 채널 보기",
  noAvailableChannels: "선택 가능한 채널이 없습니다.",
  selectChannelFirst: "채널을 먼저 선택해 주세요.",
  connectStatus: "접속현황",
  realtimeParticipants: "실시간 참가자",
  questionCountSuffix: "문항",
  currentSession: "현재 세션",
  channelSyncDetailSuffix: "상태 동기화",
  exitPopupSaved: "퇴장팝업 설정이 저장되었습니다.",
  exitPopupSaveFailed: "퇴장팝업 설정 저장중 오류가 발생하였습니다.",
  progressSurveyTitle: "진행 서베이",
  surveyTypeField: "Type",
  surveyQuestionsField: "Questions",
  stopStreamingConfirmTitle: "송출 중단 확인",
  stopStreamingConfirmDescription: "현재 채널이 LIVE 송출 중입니다.",
  stopStreamingConfirmAction: "송출 중단",
  stopStreamingImpactPrefix: "채널의 송출을 중단하면 시청자에게 즉시 영향을 줍니다.",
  stopStreamingImpactSuffix: "정말 송출을 중단하시겠습니까?",
  switchChannelConfirmTitle: "채널 전환 확인",
  switchChannelConfirmDescription: "현재 LIVE 송출 중인 채널이 있습니다.",
  switchChannelConfirmAction: "채널 전환",
  switchChannelImpactPrefix: "채널이 LIVE 송출 중입니다. 송출을 중단하고",
  switchChannelImpactSuffix: "채널로 전환하시겠습니까?",
  recordingSaveConfirmTitle: "녹화본 저장 여부 확인",
  recordingSaveConfirmDescription: "채널을 비활성화합니다.",
  recordingSwitchSaveConfirmDescription: "현재 LIVE 채널을 종료하고 새 채널로 전환합니다.",
  recordingSaveConfirmBody: "송출 종료 후 생성되는 NCloud 녹화본을 Livee 미디어 라이브러리에 저장할까요?",
  recordingSaveCheckboxLabel: "NCloud 녹화본을 미디어 라이브러리에 저장",
  recordingSaveHelpText: "저장하지 않아도 NCloud Object Storage 원본은 삭제되지 않습니다.",
  recordingSaveAndDeactivate: "저장 후 비활성화",
  recordingSkipAndDeactivate: "저장하지 않고 비활성화",
  recordingSaveAndSwitch: "저장 후 채널 전환",
  recordingSkipAndSwitch: "저장하지 않고 전환",
  channelDetailDescription: "RTMP/StreamKey/Playback/Edge 정보를 확인합니다.",
  channelName: "채널명",
  defaultStreamingUrl: "기본 송출 URL(RTMP)",
  streamKeyMain: "Stream Key - Main",
  streamKeyMainInfo: "OBS에 입력하는 스트림 키(Main)입니다. 외부 공유에 주의하세요.",
  streamKeyBackup: "Stream Key - Backup (백업 스트림 사용 시)",
  channelCreatedAt: "채널생성일시",
  channelUsageTime: "채널 사용 시간",
  recentStreamingStartedAt: "최근 송출 시작 시간",
  recordingSetting: "녹화 설정",
  recordingSettingValue: "녹화 자동 저장 / MP4",
  siteLabel: "사이트",
  organizationLabel: "조직",
  usageEventType: "Event 타입",
  usageEventDetailType: "Event 상세 타입",
  usageEventDetail: "Event 내역",
  occurredAt: "발생 시각",
  noData: "조회된 데이터가 없습니다.",
  allChannelsTitle: "사이트 할당 전체 채널",
  allChannelsDescription: "사이트에 할당된 전체 채널 목록을 확인합니다.",
  allStatuses: "채널 상태 전체",
  searchChannelsPlaceholder: "채널명/채널ID 검색",
  channelStatusColumn: "채널 상태",
  channelNameConsoleColumn: "채널명/최근진행 콘솔",
  channelUsageTimeColumn: "채널 사용 시간",
  sessionColumn: "세션",
  eventColumn: "이벤트",
  actionColumn: "액션",
  openConsoleLink: "콘솔 바로가기",
  reclaimChannel: "채널회수",
  durationZero: "0초",
  releaseChannelFailed: "채널 세션 해제에 실패했습니다.",
  copyRtmpUrl: "RTMP URL 복사",
  copyStreamKey: "Stream Key 복사",
  copyPlaybackUrl: "Playback URL 복사",
  copyAlt: "복사",
  channelActionMenu: "채널 액션 메뉴",
  surveyTypeLabel: {
    BEFORE: "사전서베이",
    AFTER: "사후서베이",
    PROGRESS: "진행서베이",
  },
};

const EN_MESSAGES = {
  control: "Control",
  survey: "Survey",
  consolePopup: "Console Popup",
  liveChannel: "Live Channel",
  captionsPoc: "Live captions",
  exitPopup: "Exit Popup",
  fmsMain: "FMS Main",
  transmissionFms: "Transmission FMS",
  afterSurvey: "Post Survey",
  progressSurvey: "Progress Survey",
  beforeSurvey: "Pre Survey",
  menuConnection: "Menu Connection",
  realtimeExposure: "Real-time exposure",
  surveyExposure: "Survey",
  surveyEdit: "Edit Survey",
  consolePopupEdit: "Edit Console Popup",
  testStreaming: "Test Streaming",
  started: "Running",
  stopped: "Stopped",
  channelDetail: "Channel Detail",
  channelId: "Channel ID",
  status: "Status",
  close: "Close",
  cancel: "Cancel",
  basicInfo: "Basic Info",
  usageHistory: "Usage",
  requiredStreamingInfo: "Required Streaming Info",
  operationInfo: "Operation Info",
  affiliationInfo: "Affiliation",
  usageHistoryGuide: "Check event history generated by the selected channel.",
  allChannels: "View All Channels",
  noAvailableChannels: "No available channels.",
  selectChannelFirst: "Select a channel first.",
  connectStatus: "Connected",
  realtimeParticipants: "Real-time participants",
  questionCountSuffix: "questions",
  currentSession: "Current Session",
  channelSyncDetailSuffix: "status sync",
  exitPopupSaved: "Exit popup settings have been saved.",
  exitPopupSaveFailed: "An error occurred while saving exit popup settings.",
  progressSurveyTitle: "Progress Survey",
  surveyTypeField: "Type",
  surveyQuestionsField: "Questions",
  stopStreamingConfirmTitle: "Stop stream",
  stopStreamingConfirmDescription: "The current channel is live.",
  stopStreamingConfirmAction: "Stop stream",
  stopStreamingImpactPrefix: "Stopping this channel affects viewers immediately.",
  stopStreamingImpactSuffix: "Do you want to stop the stream?",
  switchChannelConfirmTitle: "Switch channel",
  switchChannelConfirmDescription: "There is a channel currently live.",
  switchChannelConfirmAction: "Switch channel",
  switchChannelImpactPrefix: "This channel is currently live. Stop it and switch to",
  switchChannelImpactSuffix: "?",
  recordingSaveConfirmTitle: "Save recording?",
  recordingSaveConfirmDescription: "This will deactivate the channel.",
  recordingSwitchSaveConfirmDescription: "This will stop the current live channel and switch to another channel.",
  recordingSaveConfirmBody: "Save the NCloud recording created after the stream ends to the Livee media library?",
  recordingSaveCheckboxLabel: "Save NCloud recording to media library",
  recordingSaveHelpText: "The original file in NCloud Object Storage is not deleted even if you do not save it.",
  recordingSaveAndDeactivate: "Save and deactivate",
  recordingSkipAndDeactivate: "Deactivate without saving",
  recordingSaveAndSwitch: "Save and switch",
  recordingSkipAndSwitch: "Switch without saving",
  channelDetailDescription: "Check RTMP, stream key, playback, and edge information.",
  channelName: "Channel name",
  defaultStreamingUrl: "Default Streaming URL (RTMP)",
  streamKeyMain: "Stream Key - Main",
  streamKeyMainInfo: "This is the main stream key for OBS. Do not share it externally.",
  streamKeyBackup: "Stream Key - Backup (when using backup ingest)",
  channelCreatedAt: "Created at",
  channelUsageTime: "Usage time",
  recentStreamingStartedAt: "Latest stream started at",
  recordingSetting: "Recording",
  recordingSettingValue: "Auto save / MP4",
  siteLabel: "Site",
  organizationLabel: "Organization",
  usageEventType: "Event type",
  usageEventDetailType: "Event detail type",
  usageEventDetail: "Event detail",
  occurredAt: "Occurred at",
  noData: "No data found.",
  allChannelsTitle: "All site channels",
  allChannelsDescription: "Check all channels assigned to this site.",
  allStatuses: "All statuses",
  searchChannelsPlaceholder: "Search channel name / ID",
  channelStatusColumn: "Status",
  channelNameConsoleColumn: "Channel / recent console",
  channelUsageTimeColumn: "Usage time",
  sessionColumn: "Session",
  eventColumn: "Event",
  actionColumn: "Action",
  openConsoleLink: "Open console",
  reclaimChannel: "Release channel",
  durationZero: "0s",
  releaseChannelFailed: "Failed to release the channel session.",
  copyRtmpUrl: "Copy RTMP URL",
  copyStreamKey: "Copy stream key",
  copyPlaybackUrl: "Copy playback URL",
  copyAlt: "Copy",
  channelActionMenu: "Channel action menu",
  surveyTypeLabel: {
    BEFORE: "Pre Survey",
    AFTER: "Post Survey",
    PROGRESS: "Progress Survey",
  },
};

const CONTROL_PANEL_CONFIGS = {
  typeA: {
    locale: "ko",
    features: {
      liveChannel: true,
      connectUsers: true,
      captionsPoc: true,
    },
    messages: KO_MESSAGES,
  },
  typeB: {
    locale: "ko",
    features: {
      liveChannel: true,
      connectUsers: true,
      captionsPoc: true,
    },
    messages: KO_MESSAGES,
  },
  typeE: {
    locale: "en",
    features: {
      liveChannel: true,
      connectUsers: true,
      captionsPoc: true,
    },
    messages: EN_MESSAGES,
  },
};

const CONNECT_USERS_VIEW_MESSAGES = {
  ko: {
    title: "실시간 참가자",
    refresh: "새로고침",
    lastUpdate: "최종 업데이트",
    totalPrefix: "총",
    totalSuffix: "명 중",
    filteredSuffix: "명",
    participantId: "참가자ID",
    name: "성명",
    accessAccount: "접속계정",
    hospitalName: "병원명",
    department: "진료과",
    connectedAt: "접속일시",
    empty: "실시간 참가자가 없습니다.",
  },
  en: {
    title: "Real-time participants",
    refresh: "Refresh",
    lastUpdate: "Last update",
    totalPrefix: "Showing",
    totalSuffix: "",
    filteredSuffix: "out of",
    participantId: "Participant ID",
    name: "Name",
    accessAccount: "Access account",
    hospitalName: "Hospital name",
    department: "Department",
    connectedAt: "Connection date",
    empty: "There are no live participants.",
  },
};

module.exports = {
  CONTROL_PANEL_CONFIGS,
  CONNECT_USERS_VIEW_MESSAGES,
};
